import { defineComponent, h } from 'vue';
// @ts-ignore
import { BNumberinput } from 'buefy/dist/esm/numberinput';
import { SetterCallback } from '@/ui/types';

interface NumberInputProps {
  value: number | string;
  min?: number | string;
  controlsPosition?: 'compact';
  size?: 'is-small';
  controlsRounded?: boolean;
  classes?: string;
}

export const NumberInput = defineComponent<NumberInputProps>({
  props: ['value', 'min', 'controlsPosition', 'size', 'controlsRounded', 'classes'],
  setup(props, context) {
    return function render() {
      return h(BNumberinput, {
        props,
        class: `number-input ${props.classes ?? ''}`,
        on: {
          input: (newValue: number) => {
            context.emit('input', newValue);
          },
        },
      });
    };
  },
});

export function numberInput(props: NumberInputProps, input: SetterCallback<number>) {
  return h(NumberInput, { props, on: { input } });
}
